// Fork of AccessBank/PoliciesProcessing. Only this file, PolicyHeader and
// MakerChecks are copied; everything else is imported from that tree.
import React from 'react'
import { connect } from 'react-redux'
import LocalizedStrings from 'react-localization'
import { hashHistory } from 'react-router'
import Grid from '@material-ui/core/Grid'
import Typography from '@mui/material/Typography'
import PolicyHeader from './Components/PolicyHeader/PolicyHeader.js'
import NavigationWrapper from '../../AccessBank/PoliciesProcessing/Components/NavigationWrapper/NavigationWrapper'
import {
  getPolicyProcessingDcpRequest,
  getPolicyProcessingCustomerQuotesRequest,
  policyActionRequest,
  setNeedActionRequest,
  setPolicyToApprove,
  resetPolicyToApprove,
  policyRejectActionRequest,
  makerCheckDecisionRequest,
  returnToPriorStageRequest,
  quotationDecisionRequest,
  addPolicyNotesRequest,
  cancelPolicyActionRequest,
  deletepolicyDocumentRequest,
  setpolicyDocumentsToDelete,
  resetPolicyDocumentToDelete,
  resetHardDeletepolicyDocumentSuccess,
  resetHardDeletepolicyDocumentError,
  getPaymentsByPolicyGuidRequest,
  initiatePaymentRequest,
  resetInitiatePayment,
  generatePolicyCheckoutLinkRequest,
  resetPolicyCheckoutLink,
  findCustomerForTransferRequest,
  resetFindCustomerForTransfer,
  switchPolicyCustomerRequest,
  resetSwitchPolicyCustomerSuccess,
  resetSwitchPolicyCustomerError
} from '../../AccessBank/PoliciesProcessing/Redux/actions'
import ApprovePolicy from '../../AccessBank/PoliciesProcessing/Components/ApprovePolicy/ApprovePolicy.js'
import RejectPolicy from '../../AccessBank/PoliciesProcessing/Components/RejectPolicy/RejectPolicy.js'
import { getAllProductsRequest } from '../../../containers/CustomerScreen/actions.es6.js'
import {
  editDebitOrderzRequest,
  getDebitOrderzRequest,
  hardDeleteDebitOrderzRequest,
  resetDebitOrderzToDelete,
  resetEditDebitOrderzError,
  resetEditDebitOrderzSuccess,
  resetHardDeleteDebitOrderzError,
  resetHardDeleteDebitOrderzSuccess,
  setDebitOrderzToDelete,
  setDebitOrderzToEdit
} from '../../../containers/CustomerScreen/components/DebitOrder/state/actions.js'
import { getCustomer } from '../../../containers/Customer/actions.es6.js'
import * as documentActions from '../../../containers/DocumentGeneration/actions.es6'
import DownloadDocument from '../../../components/DownloadDocument/DownloadDocument.js'
import EmailDocument from '../../AccessBank/PoliciesProcessing/Components/PolicyDetails/Components/EmailDocument/EmailDocument.js'
import { localisedText } from '../../../lib/localisation.es6.js'
import CancelPolicy from '../../AccessBank/PoliciesProcessing/Components/PolicyDetails/Components/CancelPolicy/CancelPolicy.js'
import PolicyNotes from '../../AccessBank/PoliciesProcessing/Components/PolicyDetails/Components/PolicyNotes/PolicyNotes.js'
import PolicyDocuments from '../../AccessBank/PoliciesProcessing/Components/PolicyDetails/Components/PolicyDocuments/PolicyDocuments.js'
import {
  createDebitOrdersDcpRequest,
  uploadPolicyDcpDocumentRequest
} from '../../../containers/Policyv2/Redux/actions.js'
import MakePayment from '../../AccessBank/PoliciesProcessing/Components/PolicyDetails/Components/MakePayment/MakePayment.js'
import AddDebitOrders from '../../AccessBank/PoliciesProcessing/Components/PolicyDetails/Components/DebitOrders/AddDebitOrders.js'
import {
  getAllAcessBankCustomerPremiumsRequest,
  removeComplexPremiumRequest,
  resetRemoveComplexPremiumSuccess,
  resetRemoveComplexPremiumError,
  setPremiumToRemove,
  resetPremiumToRemove
} from '../../AccessBank/CustomerStatus/Containers/Premiums/Redux/actions.js'
import { getAccessBankCustomerClaimsRequest } from '../../AccessBank/CustomerStatus/Containers/Claims/redux/actions.js'
import DeleteDocument from '../../AccessBank/PoliciesProcessing/Components/PolicyDetails/Components/DeleteDocument/DeleteDocument.js'
import {
  getAllPoliciesRequest,
  policyNotesAddRequest,
  resetPolicyNotesAddError,
  resetPolicyNotesAddSuccess
} from '../../AccessBank/CustomerStatus/Redux/actions.js'
import DeleteDebitOrder from '../../AccessBank/CustomerStatus/Containers/DebitOrders/Components/DeleteDebitOrder/DeleteDebitOrder.js'
import RemovePremium from '../../AccessBank/PoliciesProcessing/Components/PolicyDetails/Components/Premiums/RemovePremium.js'
import {
  changeQuoteRequest,
  createQuoteRequest,
  resetChangeQuoteError,
  resetChangeQuoteSuccess,
  resetQuoteError,
  resetQuoteSuccess,
  setQuotationToReCreate
} from '../../AccessBank/PolicyAdmin/Redux/actions.js'
import EditDebitOrder from '../../AccessBank/PoliciesProcessing/Components/PolicyDetails/Components/EditDebitOrder/EditDebitOrder.js'
import { reloadPage } from '../../../lib/utils.es6.js'
import ApprovalStages from './Components/ApprovalStages/ApprovalStages'
import RejectedPolicyActionDialog from './Components/RejectedPolicyAction/RejectedPolicyActionDialog'
import UpdateBeneficiary from '../../AccessBank/PoliciesProcessing/Components/PolicyDetails/Components/UpdateBeneficiary/UpdateBeneficiary.js'
import {
  getPartnerGuid,
  getUserEmail,
  getUserFullname,
  getUserGuid
} from '../../../lib/access.es6.js'
import { correctedForStageUpdate } from '../../../components/RecentPolicies/Components/makerCheckStage'
import {
  PARTNERS_WITH_POLICY_NUMBER_SPECIAL_CHARACTORS,
  PARTNERS_GUID_ENUM
} from '../../../routes/PartnersEnum.js'
import {
  ESCALATED_KEY,
  MANAGEMENT_OUTCOME_KEY,
  MANAGEMENT_REJECTED,
  isEscalatedToManagement
} from '../lib/makerCheckerQueues.js'
import PolicyUpgrade from '../../AccessBank/CustomerStatus/Containers/PolicyUpgrade/PolicyUpgrade.js'
import InitiatePayment from '../../AccessBank/PoliciesProcessing/Components/InitiatePayment/InitiatePayment.js'
import TransferPolicy from '../../AccessBank/PoliciesProcessing/Components/PolicyDetails/Components/TransferPolicy/TransferPolicy.js'
import CancellationRequestDialog from './Components/CancellationRequestDialog/CancellationRequestDialog.js'

// Review-queue dashboards the Approve/Reject dashboard-origin gate accepts —
// see cameFromPolicyDashboard() and PolicyHeader.js. Other views that link
// here (Recent Policies, customer status, search, amended-policies) do not
// set this, so they intentionally fail the gate.
const POLICY_DASHBOARD_ORIGINS = [
  'policies_dashboard',
  'aml_dashboard',
  'pep_dashboard',
  'iprs_dashboard'
]

function PolicyNotFoundState() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        textAlign: 'center',
        padding: '40px'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="180"
        height="180"
        viewBox="0 0 180 180"
        fill="none"
      >
        <rect
          x="30"
          y="10"
          width="100"
          height="130"
          rx="6"
          fill="#F5F5F5"
          stroke="#E0E0E0"
          strokeWidth="2"
        />
        <path d="M100 10 L130 40 H100 V10Z" fill="#E0E0E0" />
        <rect x="45" y="60" width="60" height="6" rx="3" fill="#E0E0E0" />
        <rect x="45" y="76" width="72" height="6" rx="3" fill="#E0E0E0" />
        <rect x="45" y="92" width="48" height="6" rx="3" fill="#E0E0E0" />
        <circle
          cx="120"
          cy="130"
          r="14"
          fill="none"
          stroke="#EF5350"
          strokeWidth="3"
        />
        <line
          x1="130"
          y1="140"
          x2="143"
          y2="153"
          stroke="#EF5350"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <line
          x1="113"
          y1="123"
          x2="127"
          y2="137"
          stroke="#EF5350"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <line
          x1="127"
          y1="123"
          x2="113"
          y2="137"
          stroke="#EF5350"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
      </svg>
      <h2
        style={{
          color: '#424242',
          marginTop: '24px',
          marginBottom: '8px',
          fontSize: '22px'
        }}
      >
        Policy Not Found
      </h2>
      <p style={{ color: '#757575', margin: '0', fontSize: '15px' }}>
        We couldn't find a policy matching that number.
      </p>
      <p style={{ color: '#757575', marginTop: '4px', fontSize: '15px' }}>
        Please check the policy number and try again.
      </p>
    </div>
  )
}

// Option-B AML sync (frontend-owned). The backend cannot filter review queues
// by maker_checks, so the AML review queue keeps filtering on
// additional_details.aml_flagged. To make EVERY policy go through AML review we
// mirror the universal "AML Check" maker-check stage into that flag: set it the
// moment AML Check becomes the active (lowest-sequence Pending) stage — i.e. a
// prior stage was just approved and AML Check is next — so the policy surfaces
// for an AML reviewer; and clear it once the AML Check stage itself is decided,
// so the policy leaves the queue.
//
// OMM runs TWO AML gates: "AML Approval" (type AmlApproval) is the SYSTEM-flagged
// review whose aml_flagged is owned by the backend screening — we must not touch
// it here; and "AML Check" (type AgentApproval) is the UNIVERSAL gate every
// policy must pass, which the system never flags, so we own surfacing it. Its
// type is shared with the other agent-approval stages (Sales/Quality), so the
// only reliable discriminator is the label.
const AML_CHECK_LABEL = 'aml check'

function isAmlCheck(check) {
  return (
    !!check &&
    typeof check.label === 'string' &&
    check.label.trim().toLowerCase() === AML_CHECK_LABEL
  )
}

function computeAmlFlagUpdate(dcp, decision, checkGuid) {
  if (!dcp || !Array.isArray(dcp.maker_checks)) {
    return null
  }
  const checks = dcp.maker_checks
    .slice()
    .sort((a, b) => (a.sequence || 0) - (b.sequence || 0))

  let decided = null
  for (let i = 0; i < checks.length; i++) {
    if (checks[i].guid === checkGuid) {
      decided = checks[i]
      break
    }
  }
  if (!decided) {
    return null
  }

  let nextFlag = null
  if (isAmlCheck(decided)) {
    // The AML Check itself was decided (approved or rejected): leave the queue.
    nextFlag = false
  } else if (decision === 'Approved') {
    // A prior stage was approved; if AML Check is now the active stage, surface
    // the policy for AML review.
    let next = null
    for (let i = 0; i < checks.length; i++) {
      if (checks[i].guid !== decided.guid && checks[i].status === 'Pending') {
        next = checks[i]
        break
      }
    }
    if (isAmlCheck(next)) {
      nextFlag = true
    }
  }
  if (nextFlag === null) {
    return null
  }

  const ad = dcp.additional_details || {}
  if (!!ad.aml_flagged === nextFlag) {
    // Flag already in the desired state; nothing to persist.
    return null
  }
  return {
    policy_guid: dcp.guid,
    additional_details: { ...ad, aml_flagged: nextFlag }
  }
}

function computeEscalationDelta(dcp, decision) {
  if (!isEscalatedToManagement(dcp)) {
    return null
  }
  const delta = {}
  delta[ESCALATED_KEY] = false
  if (decision === 'Rejected') {
    delta[MANAGEMENT_OUTCOME_KEY] = MANAGEMENT_REJECTED
  }
  return delta
}

export class PoliciesProcessing extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      openRejectPolicyDialog: false,
      labels: new LocalizedStrings(localisedText),
      openCancelPolicyDialog: false,
      openPolicyNoteDialog: false,
      openPolicyDocumentDialog: false,
      openAddPaymentDialog: false,
      openAddDebitOrderDialog: false,
      openEditDebitOrderDialog: false,
      openUpdateBeneficaryyDialog: false,
      updateAction: null,
      rejectedPolicyAction: null,
      openPolicyToUpgrade: false,
      policyToUpgrade: null,
      policyForPaymentRequest: null,
      quoteToDownload: null,
      policyToDownloadContent: null,
      openTransferPolicyDialog: false,
      policyToEmail: null,
      openCancellationRequestDialog: false,
      cancellationFormData: {
        reason: '',
        effective_date: '',
        notes: ''
      }
    }
  }

  componentDidMount() {
    const partnerGuid = getPartnerGuid()
    if (PARTNERS_WITH_POLICY_NUMBER_SPECIAL_CHARACTORS.includes(partnerGuid)) {
      const searchStr = '-processing/'
      const hashIndex =
        this.props.location.pathname.indexOf(searchStr) + searchStr.length

      const policy_number = this.props.location.pathname.substring(hashIndex)
      console.log('Policy Number: ', policy_number)

      const encodedPolicyNumber = encodeURIComponent(policy_number)

      this.props.dispatch(
        getPolicyProcessingDcpRequest({
          policy_number: encodedPolicyNumber
        })
      )
    } else {
      const policy_number = this.props.params.policy_number
      this.getPolicy(policy_number)
    }
  }

  getPolicy(policy_number) {
    this.props.dispatch(
      getPolicyProcessingDcpRequest({
        policy_number
      })
    )
  }

  // Approve/Reject on OMK should only be actionable when the operator
  // arrived from a review queue, not from any other view of policy details
  // (Recent Policies, customer status, search, etc.) — see PolicyHeader.js.
  cameFromPolicyDashboard() {
    const from =
      this.props.location &&
      this.props.location.query &&
      this.props.location.query.from
    return POLICY_DASHBOARD_ORIGINS.includes(from)
  }

  componentWillMount() {
    this.props.dispatch(getAllProductsRequest())
  }

  toggleOpenRejectPolicyDialog() {
    this.setState({
      openRejectPolicyDialog: !this.state.openRejectPolicyDialog
    })
  }

  toggleOpenCancelPolicyDialog() {
    this.setState({
      openCancelPolicyDialog: !this.state.openCancelPolicyDialog
    })
  }

  toggleUpdateBeneficaryDialog() {
    this.setState({
      openUpdateBeneficaryyDialog: !this.state.openUpdateBeneficaryyDialog
    })
  }

  toggleTransferPolicyDialog() {
    this.setState({
      openTransferPolicyDialog: !this.state.openTransferPolicyDialog
    })
  }

  toggleOpenPolicyNoteDialog() {
    this.setState({ openPolicyNoteDialog: !this.state.openPolicyNoteDialog })
  }

  toggleOpenPolicyDocumentDialog() {
    this.setState({
      openPolicyDocumentDialog: !this.state.openPolicyDocumentDialog
    })
  }

  toggleAddPaymentDialog() {
    this.setState({ openAddPaymentDialog: !this.state.openAddPaymentDialog })
  }

  toggleAddDebitOrderDialog() {
    this.setState({
      openAddDebitOrderDialog: !this.state.openAddDebitOrderDialog
    })
  }

  toggleEditDebitOrderDialog() {
    this.setState({
      openEditDebitOrderDialog: !this.state.openEditDebitOrderDialog
    })
  }

  toggleOpenCancellationRequestDialog() {
    this.setState({
      openCancellationRequestDialog: !this.state.openCancellationRequestDialog,
      cancellationFormData: {
        reason: '',
        effective_date: '',
        notes: ''
      }
    })
  }

  handleCancellationFormDataChange(field, value) {
    this.setState(prevState => ({
      cancellationFormData: {
        ...prevState.cancellationFormData,
        [field]: value
      }
    }))
  }

  getStatus() {
    const { updateAction } = this.state

    const updateActions = {
      Approve: 'Approve',
      Discard: 'Discard',
      ReConfirm: 'ReConfirm'
    }

    let status = ''

    switch (updateAction) {
      case updateActions.Approve:
        status = 'Unpaid'
        break

      case updateActions.Discard:
        status = 'Discarded'
        break

      case updateActions.ReConfirm:
        status = 'Un_Confirmed'
        break

      default:
        break
    }

    return status
  }

  approvePolicy() {
    const status = this.getStatus()
    console.log('status is : ', status)

    const dcp = this.props.PolicyProcessingData.policyProcessingDcp
    const body = { status }

    // OMM only: when approving an Unpaid policy that carries need_action
    // (it came via "Send to Review"), clear the flag so it leaves the review
    // queue and proceeds through the normal payment flow.
    if (
      getPartnerGuid() === PARTNERS_GUID_ENUM.OLDMUTUAL_MALAWI &&
      this.state.updateAction === 'Approve' &&
      dcp.additional_details &&
      dcp.additional_details.need_action
    ) {
      const preserved = { ...(dcp.additional_details || {}) }
      delete preserved.need_action
      body.additional_details = preserved
    }

    this.props.dispatch(
      policyActionRequest({
        policy_guid: dcp.guid,
        body
      })
    )
  }

  // Re-Confirm / Discard of a rejected policy. The reason goes in
  // additional_details, which the backend replaces wholesale, so the existing
  // details are kept; policy admin audits it as POLICY_RECONFIRMED/DISCARDED.
  resolveRejectedPolicy(reason) {
    const action = this.state.rejectedPolicyAction
    const dcp = this.props.PolicyProcessingData.policyProcessingDcp
    const reasonKey =
      action === 'Discard' ? 'discard_reason' : 'reconfirm_reason'
    const additional = { ...(dcp.additional_details || {}) }
    if (reason) {
      additional[reasonKey] = reason
    } else {
      delete additional[reasonKey]
    }
    this.setState({ rejectedPolicyAction: null, updateAction: action })
    this.props.dispatch(
      policyActionRequest({
        policy_guid: dcp.guid,
        body: {
          status: action === 'Discard' ? 'Discarded' : 'Un_Confirmed',
          additional_details: additional
        }
      })
    )
  }

  rejectPolicy() {
    const dcp = this.props.PolicyProcessingData.policyProcessingDcp
    const body = {
      status: 'Rejected',
      additional_details: {}
    }

    // OMM only: the backend replaces additional_details with whatever we send,
    // so the default {} wipes product data (tier, coverage_type,
    // hcp_declaration, etc.). Preserve the existing details on reject so they
    // survive a reject -> reconfirm cycle; drop need_action so a rejected
    // policy doesn't carry a stale flag. Other partners keep the original
    // clear-on-reject behaviour.
    if (getPartnerGuid() === PARTNERS_GUID_ENUM.OLDMUTUAL_MALAWI) {
      const preserved = { ...(dcp.additional_details || {}) }
      delete preserved.need_action
      body.additional_details = preserved
    }

    this.props.dispatch(
      policyRejectActionRequest({
        policy_guid: dcp.guid,
        body
      })
    )
  }

  sendForReConfirm() {
    this.props.dispatch(
      policyRejectActionRequest({
        policy_guid: this.props.PolicyProcessingData.policyProcessingDcp.guid,
        body: {
          status: 'Un_Confirmed',
          additional_details: {}
        }
      })
    )
  }

  discard() {
    this.props.dispatch(
      policyRejectActionRequest({
        policy_guid: this.props.PolicyProcessingData.policyProcessingDcp.guid,
        body: {
          status: 'Discarded',
          additional_details: {}
        }
      })
    )
  }

  makerCheckDecision(payload) {
    const dcp = this.props.PolicyProcessingData.policyProcessingDcp
    // A stage decision's reason/note must be written to the policy notes. The
    // decisions endpoint only records the decision, so we carry a note payload
    // (same shape as the standard RejectPolicy flow) for the saga to persist.
    // Rejection always carries a reason; approval carries an optional note.
    const note = payload.reason
      ? {
          note: payload.reason,
          policy_guid: dcp.guid,
          web_user: getUserFullname(),
          web_user_guid: getUserGuid()
        }
      : undefined
    // Issue 2 (option B): keep additional_details.aml_flagged in sync with the
    // AML Check maker-check stage so the AML review queue surfaces the policy.
    let amlFlagUpdate = computeAmlFlagUpdate(
      dcp,
      payload.decision,
      payload.check_guid
    )
    // Merged into one PUT: sent as two, the later would restore what the
    // earlier cleared.
    const escalationDelta = computeEscalationDelta(dcp, payload.decision)
    if (escalationDelta) {
      const base = amlFlagUpdate
        ? amlFlagUpdate.additional_details
        : dcp.additional_details || {}
      amlFlagUpdate = {
        policy_guid: dcp.guid,
        additional_details: { ...base, ...escalationDelta }
      }
    }
    this.props.dispatch(
      makerCheckDecisionRequest({
        guid: dcp.guid,
        body: payload,
        note,
        amlFlagUpdate
      })
    )
  }

  returnToPriorStage(payload) {
    const dcp = this.props.PolicyProcessingData.policyProcessingDcp
    const note = payload.reason
      ? {
          note: `Return to prior stage: ${payload.reason}`,
          policy_guid: dcp.guid,
          web_user: getUserFullname(),
          web_user_guid: getUserGuid()
        }
      : undefined
    this.props.dispatch(
      returnToPriorStageRequest({
        guid: dcp.guid,
        body: { check_guid: payload.check_guid, reason: payload.reason },
        note
      })
    )
  }

  // Both directions of the "needs changes" round trip are the same write: flip
  // additional_details.need_action and, when the user explained themselves,
  // record that as a policy note. Which queue the policy shows up in follows
  // from the flag alone.
  //
  // The policy's own status is echoed back unchanged. On a maker-checker
  // partner (CoverLink) this handoff must NOT decide or move anything — the
  // pending check stays exactly where it is, so the policy resumes at the same
  // stage when it comes back.
  // Both writes go through one action so the saga can sequence them and report
  // a single outcome — see setNeedActionRequestWatcher. Dispatching the flag and
  // the note separately let one land without the other, with no error surfaced
  // either way.
  setNeedAction(needAction, notes, direction, extraDetails) {
    const dcp = this.props.PolicyProcessingData.policyProcessingDcp
    const existing = dcp.additional_details || {}

    // The backend stamps additional_details.checker_email with the current user
    // on every PUT to api/policies/complex. This handoff is not a decision, so
    // it must not claim the checker's seat: an insurer sending a policy back
    // would otherwise be recorded as the policy's checker, overwriting the
    // final approver the maker-check service resolves. Re-asserting the stored
    // value keeps whoever actually decided.
    const preserved = {}
    if (existing.checker_email) {
      preserved.checker_email = existing.checker_email
    }

    this.props.dispatch(
      setNeedActionRequest({
        direction,
        policyUpdate: {
          policy_guid: dcp.guid,
          // No status: policy admin rejects any status on an Un_Confirmed
          // (maker-check) policy, even an unchanged one.
          body: {
            additional_details: {
              ...existing,
              ...preserved,
              ...correctedForStageUpdate(dcp, needAction),
              need_action: needAction,
              ...(extraDetails || {})
            }
          }
        },
        note: notes
          ? {
              note: notes,
              policy_guid: dcp.guid,
              web_user: getUserFullname(),
              web_user_guid: getUserGuid()
            }
          : null
      })
    )
  }

  // Returns the corrected policy for final review, to the level that asked for
  // the changes — see correctedForStageUpdate.
  sendToReview(notes) {
    this.setNeedAction(false, notes, 'sendToReview')
  }

  // Parks the policy for correction (OMM: with the capturing agent;
  // CoverLink: in the brokers' Need Action tab). Any approval level can ask.
  requestChanges(notes) {
    const dcp = this.props.PolicyProcessingData.policyProcessingDcp
    const agentEmail =
      dcp.additional_details && dcp.additional_details.agent_email
    if (agentEmail) {
      this.props.dispatch(
        documentActions.emailDocumentRequest({
          entity_guid: dcp.guid,
          event_type: 'QA_REQUEST_CHANGES',
          email_recipients: [agentEmail],
          content: {
            policy_number: dcp.policy_number,
            changes_required: notes,
            reviewer_name: getUserFullname(),
            reviewer_email: getUserEmail()
          }
        })
      )
    }
    this.setNeedAction(true, notes, 'requestChanges', {
      nb_changes_required: notes || '',
      nb_reviewer_name: getUserFullname(),
      nb_reviewer_email: getUserEmail()
    })
  }

  escalateToManagement(notes) {
    const dcp = this.props.PolicyProcessingData.policyProcessingDcp
    const existing = dcp.additional_details || {}
    const additional = { ...existing }
    additional[ESCALATED_KEY] = true

    this.props.dispatch(
      setNeedActionRequest({
        direction: 'escalate',
        policyUpdate: {
          policy_guid: dcp.guid,
          body: { additional_details: additional }
        },
        note: notes
          ? {
              note: notes,
              policy_guid: dcp.guid,
              web_user: getUserFullname(),
              web_user_guid: getUserGuid()
            }
          : null
      })
    )
  }

  amlRequestChanges(notes) {
    const dcp = this.props.PolicyProcessingData.policyProcessingDcp
    const existing = dcp.additional_details || {}
    const preserved = {}
    if (existing.checker_email) {
      preserved.checker_email = existing.checker_email
    }

    const agentEmail = existing.agent_email
    if (agentEmail) {
      this.props.dispatch(
        documentActions.emailDocumentRequest({
          entity_guid: dcp.guid,
          event_type: 'AML_REQUEST_CHANGES',
          email_recipients: [agentEmail],
          content: {
            policy_number: dcp.policy_number,
            changes_required: notes,
            reviewer_name: getUserFullname(),
            reviewer_email: getUserEmail()
          }
        })
      )
    }

    this.props.dispatch(
      setNeedActionRequest({
        direction: 'amlRequestChanges',
        policyUpdate: {
          policy_guid: dcp.guid,
          body: {
            additional_details: {
              ...existing,
              ...preserved,
              aml_need_action: true,
              aml_changes_required: notes || '',
              aml_reviewer_name: getUserFullname(),
              aml_reviewer_email: getUserEmail()
            }
          }
        },
        note: notes
          ? {
              note: notes,
              policy_guid: dcp.guid,
              web_user: getUserFullname(),
              web_user_guid: getUserGuid()
            }
          : null
      })
    )
  }

  amlSendBackForApproval(notes) {
    const dcp = this.props.PolicyProcessingData.policyProcessingDcp
    const existing = dcp.additional_details || {}
    const preserved = {}
    if (existing.checker_email) {
      preserved.checker_email = existing.checker_email
    }
    this.props.dispatch(
      setNeedActionRequest({
        direction: 'amlSendBack',
        policyUpdate: {
          policy_guid: dcp.guid,
          body: {
            additional_details: { ...existing, ...preserved, aml_need_action: false }
          }
        },
        note: notes
          ? {
              note: notes,
              policy_guid: dcp.guid,
              web_user: getUserFullname(),
              web_user_guid: getUserGuid()
            }
          : null
      })
    )
  }

  setPolicyToApprove(policy) {
    this.props.dispatch(setPolicyToApprove(policy))
    console.log('policy to approve', policy)
  }

  resetPolicyToApprove(policy) {
    this.props.dispatch(resetPolicyToApprove(policy))
  }

  getAllPayments() {
    if (this.props.PolicyProcessingData.policyProcessingDcp) {
      const policyGuid = this.props.PolicyProcessingData.policyProcessingDcp
        .guid
      const policy_number = this.props.PolicyProcessingData.policyProcessingDcp
        .policy_number

      this.props.dispatch(
        getPaymentsByPolicyGuidRequest({
          guid: policyGuid,
          policy_number
        })
      )
    }
  }

  initiatePaymentRequest(payload) {
    this.props.dispatch(initiatePaymentRequest(payload))
  }

  generatePolicyCheckoutLink(payload) {
    this.props.dispatch(generatePolicyCheckoutLinkRequest(payload))
  }

  getAllDebitOrders(payload) {
    const policy_guid = this.props.PolicyProcessingData.policyProcessingDcp.guid
    this.props.dispatch(getDebitOrderzRequest({ policy_guid }))
  }

  handleAddPolicyNotes(payload) {
    this.props.dispatch(addPolicyNotesRequest(payload))
  }

  cancelPolicy(policy) {
    this.props.dispatch(cancelPolicyActionRequest(policy))
  }

  DocumentUpload(doc) {
    const policyGuid = this.props.PolicyProcessingData.policyProcessingDcp.guid
    if (policyGuid) {
      this.props.dispatch(
        uploadPolicyDcpDocumentRequest({ ...doc, policyGuid })
      )
    }
  }

  addDebitOrder(payload) {
    this.props.dispatch(createDebitOrdersDcpRequest(payload))
  }

  editDebitOrder(payload) {
    this.props.dispatch(editDebitOrderzRequest(payload))
  }

  resetAfterSucesfulyEdit() {
    this.props.dispatch(resetEditDebitOrderzSuccess())
    reloadPage()
  }

  resetAfterFailedEdit() {
    this.props.dispatch(resetEditDebitOrderzError())
    reloadPage()
  }

  getCustomerDetails() {
    const customer_guid = this.props.PolicyProcessingData.policyProcessingDcp
      .customer_guid
    if (customer_guid) {
      this.props.dispatch(getCustomer(customer_guid))
    }
  }

  emailPolicyDocument(email) {
    this.props.dispatch(
      documentActions.emailDocumentRequest({
        entity_guid: this.state.policyToEmail.guid,
        event_type: 'NEW_POLICY_DETAILS',
        email_recipients: [email],
        content: this.state.policyToEmail
      })
    )
  }

  // CoverLink only: fetch the customer's full quotation history for the
  // Quotes tab. No-op for every other partner.
  getCustomerQuotes() {
    const partnerGuid = getPartnerGuid()
    // CoverLink shows full quote history; OMK needs the list to approve/reject
    // amendment quotations. Other partners keep the single attached quotation.
    if (
      partnerGuid !== PARTNERS_GUID_ENUM.COVER_LINK &&
      partnerGuid !== PARTNERS_GUID_ENUM.OLDMUTUAL_KENYA
    ) {
      return
    }
    const policy = this.props.PolicyProcessingData.policyProcessingDcp
    const customer_guid = policy && policy.customer_guid
    if (customer_guid) {
      this.props.dispatch(
        getPolicyProcessingCustomerQuotesRequest({ guid: customer_guid })
      )
    }
  }

  quotationDecision(guid, decision) {
    this.props.dispatch(quotationDecisionRequest({ guid, decision }))
  }

  getPremiums() {
    const currentCustomer = this.props.customerData.currentCustomer
    if (currentCustomer) {
      this.props.dispatch(
        getAllAcessBankCustomerPremiumsRequest({ guid: currentCustomer.guid })
      )
    }
  }

  handleSetPremiumToRemove(premium) {
    this.props.dispatch(setPremiumToRemove(premium))
  }

  handleResetPremiumToRemove() {
    this.props.dispatch(resetPremiumToRemove())
  }

  handleRemovePremium(payload) {
    this.props.dispatch(removeComplexPremiumRequest(payload))
  }

  getClaims() {
    const currentCustomer = this.props.customerData.currentCustomer
    if (currentCustomer) {
      this.props.dispatch(
        getAccessBankCustomerClaimsRequest({ guid: currentCustomer.guid })
      )
    }
  }

  deleteDocument() {
    this.props.dispatch(
      deletepolicyDocumentRequest({
        policy_guid: this.props.PolicyProcessingData.policyProcessingDcp.guid,
        policy_doc_guid: this.props.PolicyProcessingData.documentsToDelete.guid
      })
    )
  }

  setDocumentToDelete(document) {
    this.props.dispatch(setpolicyDocumentsToDelete(document))
    console.log('doc to delete', document)
  }

  resetDocumentToDelete() {
    this.props.dispatch(resetPolicyDocumentToDelete(document))
  }

  getCustomerPolicies() {
    const currentCustomer = this.props.customerData.currentCustomer
    if (currentCustomer) {
      this.props.dispatch(getAllPoliciesRequest({ guid: currentCustomer.guid }))
    }
  }

  deleteDebitOrder(debitOrder) {
    this.props.dispatch(hardDeleteDebitOrderzRequest(debitOrder))
  }

  setDebitOrderToDelete(debitOrder) {
    this.props.dispatch(setDebitOrderzToDelete(debitOrder))
    console.log('debits, ', debitOrder)
  }

  setDebitOrderToEdit(debitOrder) {
    this.props.dispatch(setDebitOrderzToEdit(debitOrder))
    console.log('debits, ', debitOrder)
  }

  resetDebitOrderToDelete(debitOrder) {
    this.props.dispatch(resetDebitOrderzToDelete(debitOrder))
  }

  handleCreateQuote(customer_guid) {
    hashHistory.push(`admin/create-quote/${customer_guid}`)
  }

  setQuotationToReCreate(policy) {
    this.props.dispatch(setQuotationToReCreate(policy))
    hashHistory.push(`admin/amend-policy/${policy.policy_number}`)
  }

  togglePolicyUpgradeDialog() {
    this.setState({ openPolicyToUpgrade: !this.state.openPolicyToUpgrade })
  }

  handlePolicyNotesAdd(payload) {
    this.props.dispatch(policyNotesAddRequest(payload))
  }

  render() {
    const templateDocuments = this.props.documentGenerationData
      .templateDocuments
    const updateActions = {
      Approve: 'Approve',
      Discard: 'Discard',
      ReConfirm: 'ReConfirm'
    }
    // {
    //   console.log("this.props.quoteData.createdQuote", this.props.QuoteData.createdQuote)
    // }
    // OMK does not collect premiums by debit order: the Debit Orders tab is
    // hidden for them in NavigationWrapper, so the dialogs it opens are left
    // unmounted here too.
    const showDebitOrders =
      getPartnerGuid() !== PARTNERS_GUID_ENUM.OLDMUTUAL_KENYA
    const policyErrors = this.props.PolicyProcessingData
      .get_PolicyProcessingDcp_errors
    if (policyErrors && policyErrors.status === 404) {
      return <PolicyNotFoundState />
    }
    if (this.props.PolicyProcessingData.policyProcessingDcp) {
      return (
        <>
          <ApprovalStages
            policy={this.props.PolicyProcessingData.policyProcessingDcp}
          />
          <PolicyHeader
            policy={this.props.PolicyProcessingData.policyProcessingDcp}
            toggleOpenRejectPolicyDialog={this.toggleOpenRejectPolicyDialog.bind(
              this
            )}
            policyActiveState={
              this.props.PolicyProcessingData.policyProcessingDcp.active
            }
            policyNumber={
              this.props.PolicyProcessingData.policyProcessingDcp.policy_number
            }
            plan={
              this.props.PolicyProcessingData.policyProcessingDcp.product_name
            }
            setPolicyToApprove={this.setPolicyToApprove.bind(this)}
            approvePolicy={this.approvePolicy.bind(this)}
            discard={this.discard.bind(this)}
            DocumentUpload={this.DocumentUpload.bind(this)}
            decideMakerCheck={this.makerCheckDecision.bind(this)}
            escalateToManagement={this.escalateToManagement.bind(this)}
            makerCheckDecisionLoader={
              this.props.PolicyProcessingData.makerCheckDecisionLoader
            }
            makerCheckDecisionSuccess={
              this.props.PolicyProcessingData.makerCheckDecisionSuccess
            }
            makerCheckDecisionError={
              this.props.PolicyProcessingData.makerCheckDecisionError
            }
            makerCheckDecision={
              this.props.PolicyProcessingData.makerCheckDecision
            }
            setNeedActionLoader={
              this.props.PolicyProcessingData.setNeedActionLoader
            }
            setNeedActionSuccess={
              this.props.PolicyProcessingData.setNeedActionSuccess
            }
            setNeedActionError={
              this.props.PolicyProcessingData.setNeedActionError
            }
            setNeedActionDirection={
              this.props.PolicyProcessingData.setNeedActionDirection
            }
            sendForReConfirm={this.sendForReConfirm.bind(this)}
            sendToReview={this.sendToReview.bind(this)}
            requestChanges={this.requestChanges.bind(this)}
            amlRequestChanges={this.amlRequestChanges.bind(this)}
            amlSendBackForApproval={this.amlSendBackForApproval.bind(this)}
            allowReturnToPriorStage={true}
            returnToPriorStage={this.returnToPriorStage.bind(this)}
            returnToPriorStageLoader={
              this.props.PolicyProcessingData.returnToPriorStageLoader
            }
            returnToPriorStageSuccess={
              this.props.PolicyProcessingData.returnToPriorStageSuccess
            }
            returnToPriorStageError={
              this.props.PolicyProcessingData.returnToPriorStageError
            }
            setUpdatePolicyAction={updateAction =>
              updateAction === updateActions.ReConfirm ||
              updateAction === updateActions.Discard
                ? this.setState({ rejectedPolicyAction: updateAction })
                : this.setState({ updateAction })
            }
            resetUpdatePolicyAction={() =>
              this.setState({ updateAction: null })
            }
            updateActions={updateActions}
            updateAction={this.state.updateAction}
            cameFromPolicyDashboard={this.cameFromPolicyDashboard()}
          />

          {this.props.PolicyProcessingData.policyProcessingDcp
            .additional_details &&
            this.props.PolicyProcessingData.policyProcessingDcp
              .additional_details.worksite_name && (
              <Grid
                container
                spacing={2}
                style={{ padding: '0 20px', marginTop: '4px' }}
              >
                <Grid item xs={12}>
                  <Typography variant="body2" color="textSecondary">
                    Worksite:{' '}
                    <strong>
                      {
                        this.props.PolicyProcessingData.policyProcessingDcp
                          .additional_details.worksite_name
                      }
                    </strong>{' '}
                    (
                    {
                      this.props.PolicyProcessingData.policyProcessingDcp
                        .additional_details.worksite_code
                    }
                    )
                  </Typography>
                </Grid>
              </Grid>
            )}

          <ApprovePolicy
            policy={this.props.PolicyProcessingData.policyProcessingDcp}
            policyNumber={
              this.props.PolicyProcessingData.policyProcessingDcp.policy_number
            }
            showApprovePolicyProgressAlert={
              this.props.PolicyProcessingData.policyActionLoader
            }
            showApprovePolicySuccessAlert={
              this.props.PolicyProcessingData.policyActionsuccess
            }
            showApprovePolicyErrorAlert={
              !!this.props.PolicyProcessingData.policyActionError
            }
            approvePolicyError={
              this.props.PolicyProcessingData.policyActionError
            }
            updateAction={this.state.updateAction}
            skipConfirm={
              this.state.updateAction === 'ReConfirm' ||
              this.state.updateAction === 'Discard'
            }
            approvePolicy={this.approvePolicy.bind(this)}
          />

          <RejectedPolicyActionDialog
            action={this.state.rejectedPolicyAction}
            policyNumber={
              this.props.PolicyProcessingData.policyProcessingDcp.policy_number
            }
            onCancel={() => this.setState({ rejectedPolicyAction: null })}
            onConfirm={this.resolveRejectedPolicy.bind(this)}
          />

          <RejectPolicy
            policy_guid={
              this.props.PolicyProcessingData.policyProcessingDcp.guid
            }
            openRejectPolicyDialog={this.state.openRejectPolicyDialog}
            toggleOpenRejectPolicyDialog={this.toggleOpenRejectPolicyDialog.bind(
              this
            )}
            rejectPolicy={this.rejectPolicy.bind(this)}
            handleAddPolicyNotes={this.handleAddPolicyNotes.bind(this)}
            policy={this.props.PolicyProcessingData.policyProcessingDcp}
            policyNumber={
              this.props.PolicyProcessingData.policyProcessingDcp.policy_number
            }
            showRejectPolicyProgressAlert={
              this.props.PolicyProcessingData.policyRejectActionLoader
            }
            showRejectPolicySuccessAlert={
              this.props.PolicyProcessingData.policyRejectActionsuccess
            }
            showRejectPolicyErrorAlert={
              !!this.props.PolicyProcessingData.policyRejectActionError
            }
            rejectPolicyError={
              this.props.PolicyProcessingData.policyRejectActionError
            }
          />

          <CancelPolicy
            policy={this.props.PolicyProcessingData.policyProcessingDcp}
            openCancelPolicyDialog={this.state.openCancelPolicyDialog}
            toggleOpenCancelPolicyDialog={this.toggleOpenCancelPolicyDialog.bind(
              this
            )}
            cancelPolicy={this.cancelPolicy.bind(this)}
            showCancelPolicyProgressAlert={
              this.props.PolicyProcessingData.policyNotesLoader
            }
            showCancelPolicySuccessAlert={
              this.props.PolicyProcessingData.policyNotesSuccess
            }
            showCancelPolicyErrorAlert={
              !!this.props.PolicyProcessingData.policyNotesError
            }
            cancelPolicyError={this.props.PolicyProcessingData.policyNotesError}
          />

          <UpdateBeneficiary
            policy={this.props.PolicyProcessingData.policyProcessingDcp}
            openUpdateBeneficiaryDialog={this.state.openUpdateBeneficaryyDialog}
            toggleUpdateBeneficaryDialog={this.toggleUpdateBeneficaryDialog.bind(
              this
            )}
            getPolicy={this.getPolicy.bind(this)}
          />

          <CancellationRequestDialog
            open={this.state.openCancellationRequestDialog}
            onClose={this.toggleOpenCancellationRequestDialog.bind(this)}
            policy={this.props.PolicyProcessingData.policyProcessingDcp}
            formData={this.state.cancellationFormData}
            onFormDataChange={this.handleCancellationFormDataChange.bind(this)}
          />

          <PolicyNotes
            policy_guid={
              this.props.PolicyProcessingData.policyProcessingDcp.guid
            }
            openPolicyNoteDialog={this.state.openPolicyNoteDialog}
            toggleOpenPolicyNoteDialog={this.toggleOpenPolicyNoteDialog.bind(
              this
            )}
            handleAddPolicyNotes={this.handleAddPolicyNotes.bind(this)}
            showPolicyNoteProgressAlert={
              this.props.PolicyProcessingData.policyNotesLoader
            }
            showPolicyNoteSuccessAlert={
              this.props.PolicyProcessingData.policyNotesSuccess
            }
            showPolicyNoteErrorAlert={
              !!this.props.PolicyProcessingData.policyNotesError
            }
            PolicyNoteError={this.props.PolicyProcessingData.policyNotesError}
          />
          <PolicyDocuments
            policy_guid={
              this.props.PolicyProcessingData.policyProcessingDcp.guid
            }
            openPolicyDocumentDialog={this.state.openPolicyDocumentDialog}
            toggleOpenPolicyDocumentDialog={this.toggleOpenPolicyDocumentDialog.bind(
              this
            )}
            DocumentUpload={this.DocumentUpload.bind(this)}
            savingDocument={this.props.QuoteData.UploadPolicyDcpDocumentLoader}
          />

          <MakePayment
            policyActiveState={
              this.props.PolicyProcessingData.policyProcessingDcp.active
            }
            policy_number={
              this.props.PolicyProcessingData.policyProcessingDcp.policy_number
            }
            policy_guid={
              this.props.PolicyProcessingData.policyProcessingDcp.guid
            }
            toggleAddPaymentDialog={this.toggleAddPaymentDialog.bind(this)}
            openAddPaymentDialog={this.state.openAddPaymentDialog}
          />
          {showDebitOrders && (
            <AddDebitOrders
              openAddDebitOrderDialog={this.state.openAddDebitOrderDialog}
              toggleAddDebitOrderDialog={this.toggleAddDebitOrderDialog.bind(
                this
              )}
              policy={this.props.PolicyProcessingData.policyProcessingDcp}
              customer={this.props.customerData}
              addDebitOrder={this.addDebitOrder.bind(this)}
              showAddDebitOrderProgressAlert={
                this.props.QuoteData.createDebitOrderLoader
              }
              showAddDebitOrderSuccessAlert={
                this.props.QuoteData.createDebitOrderSuccess
              }
              showAddDebitOrderErrorAlert={
                !!this.props.QuoteData.createDebitOrderError
              }
              createDebitOrderError={this.props.QuoteData.createDebitOrderError}
            />
          )}
          <DownloadDocument
            labels={this.state.labels}
            identifier="Policies"
            entityDocument={this.props.documentGenerationData.entityDocument}
            entity={this.state.policyToDownload}
            resetEntity={() => this.setState({ policyToDownload: null })}
            templates={templateDocuments}
            getTemplates={() =>
              this.props.dispatch(
                documentActions.getTemplateDocumentsRequest('Policy')
              )
            }
            getTemplatesLoader={
              this.props.documentGenerationData.getTemplateDocumentloader
            }
            isEmptyTemplatesResponse={
              this.props.documentGenerationData.isEmptyTemplates
            }
            downloadDocument={guid => {
              this.props.dispatch(
                documentActions.downloadDocumentRequest({
                  entity_guid: this.state.policyToDownload.guid,
                  template_guid: guid
                })
              )
            }}
            resetGetTemplateDocuments={() => {
              this.props.dispatch(documentActions.resetGetTemplateDocuments())
            }}
            resetDownloadDocument={() => {
              this.props.dispatch(documentActions.resetDocumentEntity())
            }}
            showDownloadDocumentProgressAlert={
              this.props.documentGenerationData.downloadDocumentLoader
            }
            showDownloadDocumentSuccessAlert={
              this.props.documentGenerationData.downloadDocumentSuccess
            }
            showDownloadDocumentErrorAlert={
              !!this.props.documentGenerationData.downloadDocumentError
            }
            downloadDocumentError={
              this.props.documentGenerationData.downloadDocumentError
            }
            resetDownloadDocumentSuccessAlert={() => {
              this.props.dispatch(
                documentActions.resetDownloadDocumentSuccess()
              )
            }}
            resetDownloadDocumentErrorAlert={() => {
              this.props.dispatch(documentActions.resetDownloadDocumentError())
            }}
            goToTemplatesPage={() => {
              hashHistory.push('admin/view_doc_templates')
            }}
          />

          <EmailDocument
            policy={this.state.policyToEmail}
            defaultEmail={
              this.props.customerData.currentCustomer &&
              this.props.customerData.currentCustomer.email
            }
            resetEntity={() => this.setState({ policyToEmail: null })}
            emailDocument={this.emailPolicyDocument.bind(this)}
            showEmailDocumentProgressAlert={
              this.props.documentGenerationData.emailDocumentLoader
            }
            showEmailDocumentSuccessAlert={
              this.props.documentGenerationData.emailDocumentSuccess
            }
            showEmailDocumentErrorAlert={
              !!this.props.documentGenerationData.emailDocumentError
            }
            resetEmailDocumentSuccessAlert={() => {
              this.props.dispatch(documentActions.resetEmailDocumentSuccess())
            }}
            resetEmailDocumentErrorAlert={() => {
              this.props.dispatch(documentActions.resetEmailDocumentError())
            }}
          />

          <DownloadDocument
            labels={this.state.labels}
            identifier="Quotations"
            entityDocument={this.props.documentGenerationData.entityDocument}
            entity={this.state.quoteToDownload}
            resetEntity={() => this.setState({ quoteToDownload: null })}
            templates={templateDocuments}
            getTemplates={() =>
              this.props.dispatch(
                documentActions.getTemplateDocumentsRequest('Quotation')
              )
            }
            getTemplatesLoader={
              this.props.documentGenerationData.getTemplateDocumentloader
            }
            isEmptyTemplatesResponse={
              this.props.documentGenerationData.isEmptyTemplates
            }
            downloadDocument={guid => {
              this.props.dispatch(
                documentActions.downloadDocumentRequest({
                  entity_guid: this.state.quoteToDownload.guid,
                  template_guid: guid
                })
              )
            }}
            resetGetTemplateDocuments={() => {
              this.props.dispatch(documentActions.resetGetTemplateDocuments())
            }}
            resetDownloadDocument={() => {
              this.props.dispatch(documentActions.resetDocumentEntity())
            }}
            showDownloadDocumentProgressAlert={
              this.props.documentGenerationData.downloadDocumentLoader
            }
            showDownloadDocumentSuccessAlert={
              this.props.documentGenerationData.downloadDocumentSuccess
            }
            showDownloadDocumentErrorAlert={
              !!this.props.documentGenerationData.downloadDocumentError
            }
            downloadDocumentError={
              this.props.documentGenerationData.downloadDocumentError
            }
            resetDownloadDocumentSuccessAlert={() => {
              this.props.dispatch(
                documentActions.resetDownloadDocumentSuccess()
              )
            }}
            resetDownloadDocumentErrorAlert={() => {
              this.props.dispatch(documentActions.resetDownloadDocumentError())
            }}
            goToTemplatesPage={() => {
              hashHistory.push('admin/view_doc_templates')
            }}
          />

          <DeleteDocument
            deleteDocument={this.deleteDocument.bind(this)}
            DocumentToDelete={this.props.PolicyProcessingData.documentsToDelete}
            resetDocumentToDelete={this.resetDocumentToDelete.bind(this)}
            showDeleteDocumentProgressAlert={
              this.props.PolicyProcessingData.hardDeleteDocumentLoader
            }
            showDeleteDocumentSuccessAlert={
              this.props.PolicyProcessingData.hardDeleteDocumentSuccess
            }
            showDeleteDocumentErrorAlert={
              !!this.props.PolicyProcessingData.deleteDocumentError
            }
            deleteDocumentError={
              this.props.PolicyProcessingData.deleteClaimDocumentError
            }
            resetDeleteDocumentSuccessAlert={() => {
              this.props.dispatch(resetHardDeletepolicyDocumentSuccess())
            }}
            resetDeleteDocumentErrorAlert={() => {
              this.props.dispatch(resetHardDeletepolicyDocumentError())
            }}
          />

          {showDebitOrders && (
            <DeleteDebitOrder
              debitOrder={this.props.newDebitOrderData.debitOrderToDelete}
              deleteDebitOrder={this.deleteDebitOrder.bind(this)}
              resetDebitOrderToDelete={this.resetDebitOrderToDelete.bind(this)}
              showDeleteDebitOrderProgressAlert={
                this.props.newDebitOrderData.hardDeleteDebitOrderLoader
              }
              showDeleteDebitOrderSuccessAlert={
                this.props.newDebitOrderData.hardDeleteDebitOrderSuccess
              }
              showDeleteDebitOrderErrorAlert={
                !!this.props.newDebitOrderData.hardDeleteDebitOrderError
              }
              deleteDebitOrderError={
                this.props.newDebitOrderData.hardDeleteDebitOrderError
              }
              resetDeleteDebitOrderSuccessAlert={() => {
                this.props.dispatch(resetHardDeleteDebitOrderzSuccess())
              }}
              resetDeleteDebitOrderErrorAlert={() => {
                this.props.dispatch(resetHardDeleteDebitOrderzError())
              }}
            />
          )}

          <RemovePremium
            premiumToRemove={this.props.AccessBankPremiumData.premiumToRemove}
            policyGuid={
              this.props.PolicyProcessingData.policyProcessingDcp.guid
            }
            removePremium={this.handleRemovePremium.bind(this)}
            resetPremiumToRemove={this.handleResetPremiumToRemove.bind(this)}
            showRemovePremiumProgressAlert={
              this.props.AccessBankPremiumData.removeComplexPremiumLoader
            }
            showRemovePremiumSuccessAlert={
              this.props.AccessBankPremiumData.removeComplexPremiumSuccess
            }
            removePremiumPending={
              this.props.AccessBankPremiumData.removeComplexPremiumPending
            }
            showRemovePremiumErrorAlert={
              !!this.props.AccessBankPremiumData.removeComplexPremiumError
            }
            removePremiumError={
              this.props.AccessBankPremiumData.removeComplexPremiumError
            }
            resetRemovePremiumSuccessAlert={() => {
              this.props.dispatch(resetRemoveComplexPremiumSuccess())
            }}
            resetRemovePremiumErrorAlert={() => {
              this.props.dispatch(resetRemoveComplexPremiumError())
            }}
          />

          {showDebitOrders && (
            <EditDebitOrder
              toggleEditDebitOrderDialog={this.toggleEditDebitOrderDialog.bind(
                this
              )}
              openEditDebitOrderDialog={this.state.openEditDebitOrderDialog}
              debitOrder={this.props.newDebitOrderData.debitOrderToEdit}
              customer={this.props.customerData}
              policy={this.props.PolicyProcessingData.policyProcessingDcp}
              editDebitOrder={this.editDebitOrder.bind(this)}
              resetAfterSucesfulyEdit={this.resetAfterSucesfulyEdit.bind(this)}
              resetAfterFailedEdit={this.resetAfterFailedEdit.bind(this)}
              loader={this.props.newDebitOrderData.editDebitOrderLoader}
              debitOrderEditedSuccessfully={
                this.props.newDebitOrderData.editDebitOrderSuccess
              }
              debitEditedFailed={
                this.props.newDebitOrderData.editDebitOrderFailed
              }
              errors={this.props.newDebitOrderData.editDebitOrderError}
            />
          )}
          <section
            style={{
              background: '#FFFFFF',
              borderRadius: '8px',
              height: 'auto',
              marginTop: '30px',
              padding: '30px'
            }}
          >
            <PolicyUpgrade
              open={this.state.openPolicyToUpgrade}
              close={this.togglePolicyUpgradeDialog.bind(this)}
              policy={this.state.policyToUpgrade}
              // create quote props
              createQuote={quote => {
                this.props.dispatch(createQuoteRequest(quote))
              }}
              createdQuote={
                this.props.quoteData
                  ? this.props.quoteData.createdQuote
                  : undefined
              }
              showAddQuoteProgressAlert={
                this.props.quoteData
                  ? this.props.quoteData.createQuoteLoader
                  : false
              }
              resetAddQuoteSuccessAlert={() => {
                this.props.dispatch(resetQuoteSuccess())
              }}
              resetAddQuoteErrorAlert={() => {
                this.props.dispatch(resetQuoteError())
              }}
              showAddQuoteErrorAlert={
                this.props.quoteData
                  ? !!this.props.quoteData.createQuoteError
                  : false
              }
              // change quote policy props
              changeQuote={quote => {
                this.props.dispatch(changeQuoteRequest(quote))
              }}
              changeQuoteProgressAlert={
                this.props.quoteData
                  ? this.props.quoteData.changeQuoteLoader
                  : false
              }
              changeQuoteSuccessAlert={
                this.props.quoteData
                  ? this.props.quoteData.changeQuoteSuccess
                  : false
              }
              changedQuote={
                this.props.quoteData
                  ? this.props.quoteData.changeQuote
                  : undefined
              }
              changeQuoteErrorAlert={
                this.props.quoteData
                  ? !!this.props.quoteData.changeQuoteError
                  : false
              }
              changeQuoteError={
                this.props.quoteData
                  ? this.props.quoteData.changeQuoteError
                  : undefined
              }
              resetChangeQuoteSuccessAlert={() => {
                this.props.dispatch(resetChangeQuoteSuccess())
              }}
              resetChangeQuoteErrorAlert={() => {
                this.props.dispatch(resetChangeQuoteError())
              }}
              // add policy notes props
              addPolicyNote={this.handlePolicyNotesAdd.bind(this)}
              showAddPolicyNoteProgressAlert={
                this.props.PolicyProcessingData
                  ? this.props.PolicyProcessingData.policyNotesToAddLoader
                  : false
              }
              showAddPolicyNoteSuccessAlert={
                this.props.PolicyProcessingData
                  ? this.props.PolicyProcessingData.policyNotesToAddSuccess
                  : false
              }
              showAddPolicyNoteErrorAlert={
                this.props.PolicyProcessingData
                  ? !!this.props.PolicyProcessingData.policyNotesToAddError
                  : false
              }
              AddPolicyNoteError={
                this.props.PolicyProcessingData
                  ? this.props.PolicyProcessingData.policyNotesToAddError
                  : undefined
              }
              resetAddPolicyNoteSuccessAlert={() => {
                this.props.dispatch(resetPolicyNotesAddSuccess())
                reloadPage()
              }}
              resetAddPolicyNoteErrorAlert={() => {
                this.props.dispatch(resetPolicyNotesAddError())
              }}
            />
            <PolicyUpgrade
              open={this.state.openPolicyToUpgrade}
              close={this.togglePolicyUpgradeDialog.bind(this)}
              policy={this.state.policyToUpgrade}
              // create quote props
              createQuote={quote => {
                this.props.dispatch(createQuoteRequest(quote))
              }}
              createdQuote={this.props.QuoteData.createdQuote}
              showAddQuoteProgressAlert={this.props.QuoteData.createQuoteLoader}
              resetAddQuoteSuccessAlert={() => {
                this.props.dispatch(resetQuoteSuccess())
              }}
              resetAddQuoteErrorAlert={() => {
                this.props.dispatch(resetQuoteError())
              }}
              showAddQuoteErrorAlert={!!this.props.QuoteData.createQuoteError}
              // change quote policy props
              changeQuote={quote => {
                this.props.dispatch(changeQuoteRequest(quote))
              }}
              changeQuoteProgressAlert={this.props.QuoteData.changeQuoteLoader}
              changeQuoteSuccessAlert={this.props.QuoteData.changeQuoteSuccess}
              changedQuote={this.props.QuoteData.changeQuote}
              changeQuoteErrorAlert={!!this.props.QuoteData.changeQuoteError}
              changeQuoteError={this.props.QuoteData.changeQuoteError}
              resetChangeQuoteSuccessAlert={() => {
                this.props.dispatch(resetChangeQuoteSuccess())
              }}
              resetChangeQuoteErrorAlert={() => {
                this.props.dispatch(resetChangeQuoteError())
              }}
              // add policy notes props
              addPolicyNote={this.handlePolicyNotesAdd.bind(this)}
              showAddPolicyNoteProgressAlert={
                this.props.AccessBankPolicyData.policyNotesToAddLoader
              }
              showAddPolicyNoteSuccessAlert={
                this.props.AccessBankPolicyData.policyNotesToAddSuccess
              }
              showAddPolicyNoteErrorAlert={
                !!this.props.AccessBankPolicyData.policyNotesToAddError
              }
              AddPolicyNoteError={
                this.props.AccessBankPolicyData.policyNotesToAddError
              }
              resetAddPolicyNoteSuccessAlert={() => {
                this.props.dispatch(resetPolicyNotesAddSuccess())
                reloadPage()
              }}
              resetAddPolicyNoteErrorAlert={() => {
                this.props.dispatch(resetPolicyNotesAddError())
              }}
            />

            <InitiatePayment
              policy={this.state.policyForPaymentRequest}
              customer={this.props.customerData}
              resetInitiatePolicy={() => {
                this.setState({ policyForPaymentRequest: null })
                this.props.dispatch(resetInitiatePayment())
              }}
              initiatePaymentRequest={this.initiatePaymentRequest.bind(this)}
              showInitiatePaymentProgressAlert={
                this.props.PolicyProcessingData.initiatePaymentLoader
              }
              showInitiatePaymentSuccessAlert={
                this.props.PolicyProcessingData.initiatePaymentSuccess
              }
              showInitiatePaymentErrorAlert={
                !!this.props.PolicyProcessingData.initiatePaymentError
              }
              initiatePaymentError={
                this.props.PolicyProcessingData.initiatePaymentError
              }
            />

            <TransferPolicy
              policy={this.props.PolicyProcessingData.policyProcessingDcp}
              openTransferPolicyDialog={this.state.openTransferPolicyDialog}
              toggleTransferPolicyDialog={this.toggleTransferPolicyDialog.bind(
                this
              )}
              findCustomerForTransfer={args => {
                this.props.dispatch(findCustomerForTransferRequest(args))
              }}
              findCustomerForTransferLoader={
                this.props.PolicyProcessingData.findCustomerForTransferLoader
              }
              foundCustomersForTransfer={
                this.props.PolicyProcessingData.foundCustomersForTransfer
              }
              findCustomerForTransferError={
                this.props.PolicyProcessingData.findCustomerForTransferError
              }
              resetFindCustomerForTransfer={() => {
                this.props.dispatch(resetFindCustomerForTransfer())
              }}
              switchPolicyCustomer={args => {
                this.props.dispatch(switchPolicyCustomerRequest(args))
              }}
              switchPolicyCustomerLoader={
                this.props.PolicyProcessingData.switchPolicyCustomerLoader
              }
              switchPolicyCustomerSuccess={
                this.props.PolicyProcessingData.switchPolicyCustomerSuccess
              }
              switchPolicyCustomerError={
                this.props.PolicyProcessingData.switchPolicyCustomerError
              }
              resetSwitchPolicyCustomerSuccess={() => {
                this.props.dispatch(resetSwitchPolicyCustomerSuccess())
              }}
              resetSwitchPolicyCustomerError={() => {
                this.props.dispatch(resetSwitchPolicyCustomerError())
              }}
            />
            <NavigationWrapper
              policy={this.props.PolicyProcessingData.policyProcessingDcp}
              getAllPayments={this.getAllPayments.bind(this)}
              getAllDebitOrders={this.getAllDebitOrders.bind(this)}
              payments={this.props.PolicyProcessingData.policiesPaymentByGuid}
              loader={
                this.props.PolicyProcessingData.get_PaymentsByPolicyGuid_loader
              }
              getCustomerDetails={this.getCustomerDetails.bind(this)}
              getCustomerQuotes={this.getCustomerQuotes.bind(this)}
              customerQuotes={this.props.PolicyProcessingData.customerQuotes}
              customerQuotesLoader={
                this.props.PolicyProcessingData.customerQuotesLoader
              }
              customerQuotesError={
                this.props.PolicyProcessingData.customerQuotesError
              }
              quotationDecision={this.quotationDecision.bind(this)}
              quotationDecisionLoader={
                this.props.PolicyProcessingData.quotationDecisionLoader
              }
              quotationDecisionSuccess={
                this.props.PolicyProcessingData.quotationDecisionSuccess
              }
              quotationDecisionError={
                this.props.PolicyProcessingData.quotationDecisionError
              }
              customer={this.props.customerData}
              newDebitOrderData={this.props.newDebitOrderData.debitOrders}
              debitOrderloader={
                this.props.newDebitOrderData.getDebitOrderLoader
              }
              templateDocuments={
                this.props.documentGenerationData.templateDocuments
              }
              setPolicyToDownloadDocumentFor={policy =>
                this.setState({ policyToDownload: policy })
              }
              setPolicyToEmailDocumentFor={policy =>
                this.setState({ policyToEmail: policy })
              }
              setQuoteToDownloadDocumentFor={quote =>
                this.setState({ quoteToDownload: quote })
              }
              toggleOpenCancelPolicyDialog={this.toggleOpenCancelPolicyDialog.bind(
                this
              )}
              toggleUpdateBeneficaryDialog={this.toggleUpdateBeneficaryDialog.bind(
                this
              )}
              toggleOpenPolicyDocumentDialog={this.toggleOpenPolicyDocumentDialog.bind(
                this
              )}
              toggleOpenPolicyNoteDialog={this.toggleOpenPolicyNoteDialog.bind(
                this
              )}
              toggleAddPaymentDialog={this.toggleAddPaymentDialog.bind(this)}
              toggleUpgradeDialog={() =>
                this.setState({
                  openUpgradeDialog: !this.state.openUpgradeDialog
                })
              }
              toggleAddDebitOrderDialog={this.toggleAddDebitOrderDialog.bind(
                this
              )}
              policyGuid={
                this.props.PolicyProcessingData.policyProcessingDcp.guid
              }
              getPremiums={this.getPremiums.bind(this)}
              premiums={this.props.AccessBankPremiumData.premiums}
              premiumsloader={
                this.props.AccessBankPremiumData.get_premiums_loader
              }
              setPremiumToRemove={this.handleSetPremiumToRemove.bind(this)}
              getClaims={this.getClaims.bind(this)}
              claims={this.props.AccessBankClaimsData.claims}
              claimsloader={this.props.AccessBankClaimsData.get_claims_loader}
              setDocumentToDelete={this.setDocumentToDelete.bind(this)}
              policyActiveState={
                this.props.PolicyProcessingData.policyProcessingDcp.active
              }
              getCustomerPolicies={this.getCustomerPolicies.bind(this)}
              setDebitOrderToDelete={this.setDebitOrderToDelete.bind(this)}
              setQuotationToReCreate={this.setQuotationToReCreate.bind(this)}
              setDebitOrderToEdit={this.setDebitOrderToEdit.bind(this)}
              toggleEditDebitOrderDialog={this.toggleEditDebitOrderDialog.bind(
                this
              )}
              openEditDebitOrderDialog={this.state.openEditDebitOrderDialog}
              debitOrderToEdit={this.props.newDebitOrderData.debitOrderToEdit}
              customer_guid={
                this.props.PolicyProcessingData.policyProcessingDcp
                  .customer_guid
              }
              togglePolicyUpgradeDialog={this.togglePolicyUpgradeDialog.bind(
                this
              )}
              setPolicyToUpgrade={policy =>
                this.setState({ policyToUpgrade: policy })
              }
              setPaymentInitiation={policy => {
                this.setState({ policyForPaymentRequest: policy })
              }}
              toggleTransferPolicyDialog={this.toggleTransferPolicyDialog.bind(
                this
              )}
              generatePolicyCheckoutLink={this.generatePolicyCheckoutLink.bind(
                this
              )}
              checkoutLinkLoader={
                this.props.PolicyProcessingData.checkoutLinkLoader
              }
              checkoutLinkUrl={this.props.PolicyProcessingData.checkoutLinkUrl}
              checkoutLinkError={
                this.props.PolicyProcessingData.checkoutLinkError
              }
              resetPolicyCheckoutLink={() => {
                this.props.dispatch(resetPolicyCheckoutLink())
              }}
            />
          </section>
        </>
      )
    }
    return 'loading'
  }
}
export default connect(state => ({
  customerData: state.currentCustomer,
  AccessBankPremiumData: state.AccessBankPremiumData,
  AccessBankClaimsData: state.AccessBankClaimsData,
  documentGenerationData: state.documentGeneration,
  PoliciesDashboardData: state.PoliciesDashboardData,
  PolicyProcessingData: state.PolicyProcessingData,
  customerScreenData: state.customerScreen,
  newDebitOrderData: state.newDebitOrder,
  QuoteData: state.quoteData,
  AccessBankPolicyData: state.AccessBankPolicyData,
  globalData: state.global
}))(PoliciesProcessing)
